var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx } from '@emotion/core'; // @ts-ignore

import { arrowDown_16, arrowUp_16 } from '@trustpilot/icons';
import { Popover, Icon } from '../..';
import { COLORS, GRID, FONT, BORDER_RADIUS } from '../../constants';

var Arrow = function Arrow(_a) {
  var direction = _a.direction;
  return jsx(Icon, {
    content: direction === 'positive' ? arrowUp_16 : arrowDown_16,
    css: {
      width: 12,
      height: 12,
      marginRight: 4,
      fill: direction === 'positive' ? COLORS.spot.success : COLORS.spot.critical
    }
  });
};

export var ChangeIndicator = function ChangeIndicator(_a) {
  var value = _a.value,
      direction = _a.direction,
      tooltip = _a.tooltip;
  return jsx(Popover, {
    content: tooltip
  }, jsx("span", {
    css: __assign({
      display: 'inline-flex',
      marginLeft: GRID.small,
      padding: "0 " + GRID.xsmall,
      alignItems: 'center',
      background: COLORS.grays.lightest,
      borderRadius: BORDER_RADIUS.medium,
      fontWeight: FONT.weight.bold
    }, FONT.sizes.regular)
  }, direction !== 'no-change' && jsx(Arrow, {
    direction: direction
  }), value));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/NumberHighlightCard/ChangeIndicator.js
// module id = 1221
// module chunks = 0